let ctx = null;
let muted = typeof localStorage !== "undefined" && localStorage.getItem("syn-muted") === "1";

const ac = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const env = (g, t0, attack, decay, peak) => {
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.linearRampToValueAtTime(peak, t0 + attack);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + attack + decay);
};

const tone = (type, freq, at, attack, decay, peak) => {
  const c = ac();
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, at);
  env(g, at, attack, decay, peak);
  o.connect(g).connect(c.destination);
  o.start(at);
  o.stop(at + attack + decay + 0.02);
};

export const sfx = {
  tick() {
    if (muted) return;
    try { tone("square", 2200, ac().currentTime, 0.002, 0.03, 0.012); } catch {}
  },
  pass() {
    if (muted) return;
    try { tone("sine", 880, ac().currentTime, 0.004, 0.07, 0.025); } catch {}
  },
  confirm() {
    if (muted) return;
    try {
      const t = ac().currentTime;
      tone("sine", 660, t, 0.005, 0.14, 0.03);
      tone("sine", 990, t + 0.09, 0.005, 0.16, 0.03);
    } catch {}
  },
};

export const isMuted = () => muted;
export const setMuted = (m) => {
  muted = m;
  try { localStorage.setItem("syn-muted", m ? "1" : "0"); } catch {}
};
